import React from 'react';
import { Highlight } from './Heading';
import { SectionHeader } from './SectionHeader';
import { Reveal } from './Reveal';
import { members } from '../data/members';
export function MembersSection() {
  // Duplicated so the marquee loops seamlessly
  const loop = [...members, ...members];
  return <section id="miembros" className="bg-white py-14 md:py-16" data-id="element-334" data-mp="2kjvmqp5r4wbs">
      <div className="mx-auto max-w-7xl px-6" data-id="element-335" data-mp="2kmq5mc94a933">
        <SectionHeader eyebrow="Miembros" title={<>
              Empresas del <Highlight tone="accent" data-id="element-337" data-mp="1su97ydqjnzv5">Grupo Consultor</Highlight>
            </>} subtitle="Firmas con trayectoria que suman conocimiento, experiencia y criterio al servicio de la región." data-id="element-336" data-mp="1wvugxnzyju02" />
      </div>

      <Reveal delay={0.1} className="mt-10" data-id="element-338" data-mp="21skw893xulkf">
        <div className="group relative overflow-hidden" style={{
        WebkitMaskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)',
        maskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)'
      }} data-id="element-339" data-mp="3i7mfscxv8610">
          <ul className="marquee flex w-max gap-5 py-3 group-hover:[animation-play-state:paused]" data-id="element-340" data-mp="1ss3qzg82fb3x">
            {loop.map((m, i) => <li key={`${m.id}-${i}`} aria-hidden={i >= members.length} className="flex h-28 w-52 shrink-0 items-center justify-center rounded-2xl bg-white p-5 ring-1 ring-primary/10 transition hover:-translate-y-1 hover:shadow-md sm:h-32 sm:w-60" data-id="element-341" data-mp="1xsrevt0zzbtx" data-mpi={i}>
                <img src={m.logo} alt={i < members.length ? m.name : ''} loading="lazy" className="max-h-full max-w-full object-contain" data-id="element-342" data-mp="1a0axlkp33nvo" />
              </li>)}
          </ul>
        </div>
      </Reveal>
    </section>;
}